import GraphqlBase from './graphql-base'

import { generateMutation } from './graphql-helpers'
import { omitDeep } from 'vessel/utils'

export default class GraphqlMutation extends GraphqlBase {
  constructor({ mutation, ...options }) {
    super(options)

    this.mutation  = mutation
    this.generator = generateMutation
  }

  get file() {
    return this.mutation
  }

  get dataObject() {
    return {
      fullData: null,
      data: null,
      info: null
    }
  }

  get attrs() {
    return {
      mutation: this.definition,
      clientId: this.client,
      ...this.options
    }
  }

  parseResult(result) {
    const parsed = this.dataObject
    const data   = Object(result.data)
    const objKey = Object.keys(data)[0]
    const object = omitDeep(data[objKey], ['__typename'])

    parsed.fullData = result.data

    if (object) {
      const infoKeys = ['errors', 'messages', 'notice', 'status']
      const metaKeys = ['actionInfo', ...infoKeys]
      const dataKey  = this.root || Object.keys(object).find(key => !metaKeys.includes(key))

      parsed.info = object.actionInfo || Object.entries(object).reduce((infos, [key, value]) => {
        if (infoKeys.includes(key))
          infos[key] = value

        return infos
      }, {})

      parsed.data = object[dataKey]
    }

    return parsed
  }

  async execute(provider) {
    const client = provider.clients[this.client]

    return client.mutate({ ...this.attrs, context: this.context })
      .then(res => this.parseResult(res))
      .catch(res => console.log(res))
  }
}
